import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ArrowRight } from '@element-plus/icons-vue';
export default {
  setup() {
    const route = useRoute();
    let paths = ref([]);
    watch(() => route.matched, val => {
      paths.value = val.filter(i => i.path !== '/');
    }, {
      immediate: true
    });
    return {
      paths,
      ArrowRight
    };
  }
};